import React, { Component } from 'react';
import './App.css';
import sf from './img/sf.png';
import {firstName, lastName} from './Utils';

class App extends Component {
  componentDidMount() {
    document.title = firstName() + " and " + lastName()
  }
  render() {

    return (
      <div className="App">
        {this.props.children}
        <img className="App-footer" src={sf} alt="SF"/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js